// import {Store, applyMiddleware, createStore} from 'redux';
// import {RootState, rootReducer} from './reducers/root-reducer';
//
// export const initialStore: Store<RootState> = createStore(rootReducer, applyMiddleware());
import { createStore } from 'redux';
import { rootReducer } from './reducers/root-reducer';

export const initialStore = createStore(rootReducer);

export type RootState = ReturnType<typeof initialStore.getState>;
